import {Route} from "@angular/router";
import {AuthLayout} from "@layouts/auth/auth.layout";
import { guestGuard } from '@guards/guest.guard';

export const routes: Route[] = [
  {
    path: 'auth',
    component: AuthLayout,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () => import('@components/pages/auth/login/login.component').then(m => m.LoginComponent),
        title: 'Login'
      },
      {
        path: 'signup',
        canActivate: [guestGuard],
        loadComponent: () => import('@components/pages/auth/signup/signup.component').then(m => m.SignupComponent),
        title: 'Signup'
      },
      {
        path: 'forgot-pwd',
        loadComponent: () => import('@components/pages/auth/forgot-pwd/forgot-pwd.component').then(m => m.ForgotPwdComponent),
        title: 'Forgot password'
      },
      {
        path: 'reset-pwd',
        loadComponent: () => import('@components/pages/auth/reset-pwd/reset-pwd.component').then(m => m.ResetPwdComponent),
        title: 'Reset password'
      }
    ]
  }
]
